import request from './request'
import type { iFlowType } from '@/types/index'
import { useSystemInfo } from '@/store'
// import { ACTIVITY_TYPES } from '@/consts';

// 领取奖励
// export const receiveReward = ({ activityType, id }: { activityType: keyof typeof ACTIVITY_TYPES, id: string | number }) =>
//   request({
//     url: '/carbon-promotion/private/user/activity/rewards/record/receive',
//     method: 'GET',
//     params: { activityType, id }
//   });

// 拿活动详情
export const getActivityDetail = ({
  activityId,
}: {
  activityId: string | number
}) =>
  request({
    url: '/carbon-promotion/public/activity/config/id',
    method: 'GET',
    params: { activityId, language: useSystemInfo().language },
  })

// 待领取奖励列表
export const getRewardList = () =>
  request({
    url: '/carbon-promotion/private/user/activity/rewards/record/awarded',
    method: 'GET',
  })

// 领取奖励
export const receiveReward = ({
  flowType,
  activityId,
  rewardId,
}: {
  flowType: iFlowType
  activityId?: string | number
  rewardId?: string | number
}) =>
  request({
    url: '/carbon-promotion/private/user/activity/rewards/record/receive',
    method: 'POST',
    data: {
      flowType,
      activityId,
      rewardId,
    },
  })

//待领取彩金奖励列表
export const getBonusList = () =>
  request({
    url: '/carbon-wallet/private/user/reward/collection/list',
    method: 'GET',
  })

// 领取彩金奖励
export const receiveBonus = (data: any) =>
  request({
    url: '/carbon-wallet/private/user/reward/collection/bonus',
    method: 'POST',
    data,
  })
